import React from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import LocationSection from "./components/LocationSection";
import ServicesSection from "./components/ServicesSection";
import ApartmentSection from "./components/ApartmentSection";
import ActivitiesSection from "./components/ActivitiesSection";
import GardenSection from "./components/GardenSection";
import PracticalInfoSection from "./components/PracticalInfoSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <HeroSection />
        <LocationSection />
        <ServicesSection />
        <ApartmentSection />
        <ActivitiesSection />
        <GardenSection />
        <PracticalInfoSection />
        <ContactSection />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;